import { useMemo, useState } from "react";
import { featured } from "@/mocks/chigua";

const toneClass: Record<string, string> = {
  red: "bg-primary-100 text-primary-700",
  green: "bg-accent-100 text-accent-700",
  amber: "bg-secondary-100 text-secondary-900",
};

export default function Featured() {
  const cats = useMemo(() => {
    const set = new Set<string>();
    featured.forEach((f) => set.add(f.category));
    return ["全部", ...Array.from(set)];
  }, []);

  const [active, setActive] = useState("全部");
  const list = active === "全部" ? featured : featured.filter((f) => f.category === active);

  return (
    <section id="featured" className="border-y border-background-200 bg-background-100/60">
      <div className="container-page py-12 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-accent-700">
              <i className="ri-flashlight-fill"></i>
              VIRAL PICKS
            </p>
            <h2 className="section-title mt-3">爆款精选盘点</h2>
            <p className="mt-2 text-sm text-foreground-600">
              编辑部精挑的吃瓜日报精选内容，热门排行下的深度阅读，一网打尽当下最值得看的瓜料。
            </p>
          </div>
          <span className="hidden text-sm text-foreground-500 md:block">共 {featured.length} 篇精选 · 持续更新</span>
        </div>

        {/* category filter */}
        <div className="mt-6 flex flex-wrap items-center gap-2">
          {cats.map((c) => (
            <button
              key={c}
              onClick={() => setActive(c)}
              className={`rounded-full px-4 py-1.5 text-sm font-medium whitespace-nowrap transition ${
                active === c
                  ? "bg-primary-500 text-background-50"
                  : "border border-foreground-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {/* card grid */}
        <div className="mt-7 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((f) => (
            <article
              key={f.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition hover:-translate-y-1"
            >
              <div className="relative overflow-hidden">
                <img
                  src={f.image}
                  alt={f.title}
                  className="h-44 w-full object-cover transition duration-500 group-hover:scale-105 md:h-48"
                />
                <span className={`absolute left-3 top-3 label-cat ${toneClass[f.tone]}`}>{f.tag}</span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span className={`label-cat ${toneClass[f.tone]}`}>{f.category}</span>
                  <span className="flex items-center gap-1"><i className="ri-fire-line"></i>{f.heat}</span>
                  <span className="flex items-center gap-1"><i className="ri-time-line"></i>{f.readTime} 分钟</span>
                </div>
                <h3 className="mt-3 font-display text-[17px] font-bold leading-snug text-foreground-900">
                  <a href="#special" className="transition hover:text-primary-600">{f.title}</a>
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{f.summary}</p>
                <a
                  href="#special"
                  className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-accent-700 transition group-hover:gap-2"
                >
                  阅读全文 <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>

        {list.length === 0 && (
          <p className="mt-10 text-center text-sm text-foreground-500">该分类下暂无精选内容，换个分类看看。</p>
        )}
      </div>
    </section>
  );
}